import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

// White filled input used across every auth screen, sitting on the dark
// background. Mirrors the legacy login field styling.
const LoginTextField = styled(TextField)({
  // Pin white across base, hover, focus, and disabled. MUI's filled variant
  // swaps in a translucent overlay on hover/focus that, over the dark login
  // background, reads as transparent. The state selectors below outrank it.
  "& .MuiFilledInput-root": {
    backgroundColor: "#ffffff",
    borderRadius: 3,
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    "&.Mui-focused": {
      backgroundColor: "#ffffff",
    },
    "&.Mui-disabled": {
      backgroundColor: "#ffffff",
    },
    "&:before, &:after": {
      borderBottom: "0",
    },
    "&:hover:not(.Mui-disabled, .Mui-error):before": {
      borderBottom: "0",
    },
  },
});

export default LoginTextField;
